// src/processors/resource/index.ts - Resource Module Exports
import {XConVitePluginOptions} from "../../types";

export { ResourceProcessor } from './resource-processor';
export { ResourceFileHandler } from './resource-file-handler';
export { ResourceParser } from './resource-parser';
export { ResourceValidator } from './resource-validator';
export { ResourceUrlProcessor } from './resource-url-processor';

// Convenience function for backward compatibility

import { ResourceProcessor } from './resource-processor';
import {ProcessResult} from "../../types";
import {Logger} from "../../utils/logger";

/**
 * Process resources from xchtml files (backward compatibility function)
 */
export function processResources(
    code: string,
    id: string,
    options: Required<XConVitePluginOptions>,
    addWatchFile: (file: string) => void,
    logger: Logger
): ProcessResult {
    const processor = new ResourceProcessor(options, logger);
    return processor.processResources(code, id, addWatchFile);
}